// Import GOVX Featured Products Swiper Component
import GovxFeaturedProducts from 'JsComponents/govx-featured-products';
// Import GOVX Collection List Component
import initGovxCollectionList from '../components/govx-collection-list';

document.addEventListener('DOMContentLoaded', () => {
  GovxFeaturedProducts();
  initGovxCollectionList();
});